<template>
  <link-calendar-setting
    @changeLoginGoogle="changeLoginGoogle"
    @changeLoginMicrosoft="changeLoginMicrosoft"
  />
</template>

<script>
import LinkCalendarSetting from '../../SmartScheduling/components/LinkCalendarSetting.vue'
import { mapState, mapActions } from 'vuex'
import firebaseHelper from '@/helper/firebaseHelper'

export default {
  components: {
    LinkCalendarSetting
  },
  data: () => ({
    ...mapState([
      'lang'
    ])
  }),
  methods: {
    ...mapActions([
      'setLoadingState',
      'unsetLoadingState'
    ]),
    ...mapActions('auth', [
      'setLoginByGoogle',
      'setLoginByMicrosoft'
    ]),
    changeLoginGoogle() {
      this.setLoadingState('changeLoginMethod')
      firebaseHelper.signOut().then(() => {
        return firebaseHelper.signInGoogle()
      }).then((res) => {
        return this.setLoginByGoogle(res)
      }).then(() => {
        this.$router.push({ name: 'Setup' })
      }).catch((err) => {
        this.$router.push({
          name: 'login',
          lang: this.lang
        })
      }).finally(() => {
        this.unsetLoadingState('changeLoginMethod')
      })
    },
    changeLoginMicrosoft() {
      this.setLoadingState('changeLoginMethod')
      firebaseHelper.signOut().then(() => {
        return firebaseHelper.signInMicrosoft()
      }).then((res) => {
        return this.setLoginByMicrosoft(res)
      }).then(() => {
        this.$router.push({ name: 'Setup' })
      }).catch((err) => {
        this.$router.push({
          name: 'login',
          lang: this.lang
        })
      }).finally(() => {
        this.unsetLoadingState('changeLoginMethod')
      })
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
